import React, { useState, useRef, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/common/Navbar";
import AlphabetSelector from "../components/practicePage/AlphabetSelector";
import GrouperSelector from "../components/practicePage/GrouperSelector";
import WPMSelector from "../components/practicePage/WPMSelector";
import { generateGroups } from "../utils/practicePage/GenerateGroupers";
import "../styles/practicePage/PracticePage.css";
import "../styles/common/roots.css";

const Practice = () => {
  const navigate = useNavigate();
  const resetButtonRef = useRef(null);
  const selectAllButtonRef = useRef(null);

  const [selectedLetters, setSelectedLetters] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [groupCount, setGroupCount] = useState(1);
  const [wpm, setWPM] = useState(10);
  const [randomLetter, setRandomLetter] = useState(null);
  const [reset, setReset] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleReset = () => {
    setSelectedLetters([]);
    setGroupCount(1);
    setWPM(10);
    setRandomLetter(null);
    setReset(true);

    if (resetButtonRef.current) {
      resetButtonRef.current.classList.add("activeEffect");
      setTimeout(() => {
        resetButtonRef.current.classList.remove("activeEffect");
      }, 500);
    }
  };

  const handleSelectAll = () => {
    setSelectAll(true);
    setTimeout(() => setSelectAll(false), 100); // Reset after state is updated

    // Add active effect
    if (selectAllButtonRef.current) {
      selectAllButtonRef.current.classList.add("activeEffect");
      setTimeout(() => {
        selectAllButtonRef.current.classList.remove("activeEffect");
      }, 500);
    }
  };

  // Move the useMemo hook here, outside the handleGenerate function
  const sortedLetters = useMemo(() => {
    if (typeof selectedLetters === "string") {
      return selectedLetters.split("").sort().join("");
    }
    if (Array.isArray(selectedLetters)) {
      return selectedLetters.join("").split("").sort().join("");
    }
    return "";
  }, [selectedLetters]);

  const handleGenerate = () => {
    if (selectedLetters.length <= 1) {
      alert("Please select at least 2 letters.");
      return;
    }

    const groups = generateGroups(selectedLetters, groupCount);

    // You can now safely check the length of sortedLetters
    let displayTitle = sortedLetters;
    if (sortedLetters.length > 5) {
      displayTitle = "Mixed";
    }

    // Pass the generated groups and sorted letters via state to the /test route
    navigate("/test", {
      state: { groups, displayTitle, wpm, fromPracticePage: true },
    });
  };

  const handleResetCompleted = () => {
    setReset(false);
  };

  return (
    <div>
      <Navbar />
      <div className="container-fluid containerDesktop mx-lg-5">
        <div className="mt-4 title">Practice</div>
        <div className="container mx-auto d-flex justify-content-center mt-5">
          <div>
            <AlphabetSelector
              onSelectionChange={setSelectedLetters}
              reset={reset}
              onResetCompleted={handleResetCompleted}
              selectAll={selectAll}
            />
            <GrouperSelector onGroupChange={setGroupCount} reset={reset} />
            <WPMSelector onWPMChange={setWPM} reset={reset} />
            <div className="buttonRow">
              <button
                ref={resetButtonRef}
                className="resetButton pillPP"
                onClick={handleReset}
              >
                Reset
              </button>
              <button
                ref={selectAllButtonRef}
                className="selectAllButton pillPP"
                onClick={handleSelectAll}
              >
                Select All
              </button>
            </div>

            <button className="generateButton pillPP" onClick={handleGenerate}>
              Generate
            </button>
            {randomLetter && <div>Random Letter: {randomLetter}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Practice;
